export const toCamelCase = str => str.replace(/_([a-z])/g, g => g[1].toUpperCase());

export const locateObject = (obj, locateIn) =>
  Object.fromEntries(
    Object.entries(obj).map(elem => {
      if (!Array.isArray(elem[1]) && typeof elem[1] === 'object' && elem[1]) {
        return [
          locateIn[toCamelCase(elem[0])] || toCamelCase(elem[0]),
          locateObject(elem[1], locateIn)
        ];
      }
      if (Array.isArray(elem[1]) && elem[1][0] && typeof elem[1][0] === 'object') {
        const newArray = [];
        for (let i = 0; i < elem[1].length; i += 1) {
          newArray.push(locateObject(elem[1][i], locateIn));
        }
        return [locateIn[toCamelCase(elem[0])] || toCamelCase(elem[0]), newArray];
      }
      return locateIn[toCamelCase(elem[0])]
        ? [locateIn[toCamelCase(elem[0])], elem[1]]
        : [toCamelCase(elem[0]), elem[1]];
    })
  );

export const locateIn = (obj, enumIn) => {
  if (Array.isArray(obj)) {
    const newArray = [];
    for (let i = 0; i < obj.length; i += 1) {
      newArray.push(locateObject(obj[i], enumIn));
    }
    return newArray;
  }

  return locateObject(obj, enumIn);
};

export const locateOut = (obj, enumOut) => {
  if (Array.isArray(obj)) {
    const newArray = [];
    for (let i = 0; i < obj.length; i += 1) {
      newArray.push(locateObject(obj[i], enumOut));
    }
    return newArray;
  }
  return locateObject(obj, enumOut);
};
